import {
  createDatValuesResponseObject,
  parseFileContent,
} from '../utils/sldUtils';
import Axios from '../utils/axiosClient';

const getSLDByAssetpointId = async (assetPointId) => {
  try {
    const response = await Axios.get(`/sld/substationsldfile/${assetPointId}`);
    if (response.data.statusCode === 200)
      return await parseFileContent(response.data.result.sldFileContents);
  } catch (err) {
    console.log('Error Fetching SubstationSLDFile', err);
    throw new Error('Error fetching SLD data: ' + err.message);
  }
};

const getSldDataValuesByAstpt = async (assetPointId) => {
  try {
    const response = await Axios.get(
      `/sld/slddatavaluesbyastpt/${assetPointId}`
    );
    if (response.data.statusCode === 200)
      return await createDatValuesResponseObject(response);
  } catch (err) {
    console.log('Error Fetching SldGenericDataValues', err);
    return {
      pdsData: [],
      pdsDataCols: [],
      adsData: [],
      adsDataCols: [],
      dcData: [],
      dcDataCols: [],
    };
  }
};

const getSldDIValuesByAstpt = async (assetPointId) => {
  const response = await Axios.get(`/sld/slddivaluesbyastpt/${assetPointId}`);
  if (response.data.statusCode === 200) return await response.data.result;
};

const getGenericDataValues = async (assetPointId) => {
  const response = await Axios.get(
    `/sld/sldgenericdatavalues/location/${assetPointId}`
  );
  if (response.data.statusCode === 200) return await response.data.result;
};

export {
  getSLDByAssetpointId,
  getSldDIValuesByAstpt,
  getSldDataValuesByAstpt,
  getGenericDataValues,
};
